import React from "react";
import "@frameworks/web/stylesheets/components/Reports/TransactionHistory/TransactionHistoryMain.scss";
import DeviceContext from "@frameworks/web/components/generic/customHooks/indentifyDevice";
import { NonStreamReportValue } from "@frameworks/web/components/features/Markets/Equity/commonTablemethods";
import { EachrowTransactiondata } from "../Constant";
const TxnDetailsSidebarDrawerBody = (props) => {
    var _a;
    const device = DeviceContext();
    const topRow = [
        {
            title: "Date",
            value: props.selectedRow.transactionDate,
        },
        {
            title: "Quantity",
            value: NonStreamReportValue(String(props.selectedRow.quantity)),
        },
        {
            title: "Price",
            value: NonStreamReportValue(String(props.selectedRow.transactionPrice)),
        },
    ];
    return (React.createElement("div", { className: "bg_white sidebarTransactionbody" },
        React.createElement("div", { className: "dateTransaction d-flex justify-content-between lh-140" }, topRow === null || topRow === void 0 ? void 0 : topRow.map((dataPoint) => (React.createElement("div", { className: `d-flex flex-column ` },
            React.createElement("span", { className: "txt_secondary-gray DMSansMedium_12_500" }, dataPoint.title),
            React.createElement("span", { className: "RobotoM_14_500" }, dataPoint === null || dataPoint === void 0 ? void 0 : dataPoint.value))))),
        React.createElement("div", { className: "sidebarTransactionbody-fields" }, EachrowTransactiondata.map((data, idx) => {
            return (React.createElement("div", { className: "net-transaction", key: idx },
                React.createElement("div", { className: "DMSansMedium_12_500 txt_secondary-gray" }, data.title),
                React.createElement("div", { className: "RobotoM_14_500" }, NonStreamReportValue(String(props.selectedRow[data.key])))));
        })),
        !(props === null || props === void 0 ? void 0 : props.showAlltxnsOfSelectedScrip) && (React.createElement("div", { className: `view_all-transaction  txt-midnight-blue txt-underline hand_cursor ${(device === null || device === void 0 ? void 0 : device.isDesktop)
                ? "DMSanN_14_400"
                : "RobotoM_12_500 textOverflow-max359"}`, onClick: () => {
                props.viewAllTxnOfSelectedScrip();
            } },
            "View All Transactions of ", (_a = props.selectedRow) === null || _a === void 0 ? void 0 :
            _a.security))));
};
export default TxnDetailsSidebarDrawerBody;
